// extracted by mini-css-extract-plugin
export default {"MetadataSidebarContainer":"MetadataSidebar-module__MetadataSidebarContainer--Q4Gkx","CreateIssueAssigneesSection":"MetadataSidebar-module__CreateIssueAssigneesSection--Prcsb"};